import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=387d0468&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=387d0468&prod&lang=less"
import style1 from "./Layout.vue?vue&type=style&index=1&id=387d0468&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d0468",
  null
  
)

export default component.exports